"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelPropTypes = exports.PanelHeaderPropTypes = exports.PanelFooterPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PanelHeaderPropTypes = exports.PanelHeaderPropTypes = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  title: _propTypes.default.string,
  fixed: _propTypes.default.bool,
  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
})]);
const PanelFooterPropTypes = exports.PanelFooterPropTypes = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  fixed: _propTypes.default.bool,
  content: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
})]);
const PanelPropTypes = exports.PanelPropTypes = {
  fixed: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['sliding', 'modal', 'inline']),
  open: _propTypes.default.bool,
  position: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['main', 'full', 'aside', 'small_tall', 'small', 'tiny', 'large', 'xlarge']),
  // full = full screen | main = overlays main content | aside = thin panel 400px
  _propTypes.default.string]),
  modalLabel: _propTypes.default.string,
  children: _propTypes.default.node,
  onClose: _propTypes.default.func,
  customCssClass: _propTypes.default.string,
  scrollContent: _propTypes.default.bool,
  header: PanelHeaderPropTypes,
  footer: PanelFooterPropTypes,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string),
  onPanelScroll: _propTypes.default.func
};